import React from 'react';

class transportSplit extends React.Component {
    render() {
        return <div className='dms-body'>
            {this.props.children}
        </div>
    }
};
export default transportSplit;


// WEBPACK FOOTER //
// ./src/routes/transportSplit/index.js